import Cookies from "js-cookie";
import { authCookieName } from "./constants";

const isAuthenticated = () => Cookies.get(authCookieName);

// Domain attributes the API may have scoped the flag cookie to (see the API's
// domainMap: ".dactyldata.com" in production, ".staging.dactyldata.com" on
// staging). A remove without a matching domain leaves such a cookie in place,
// so every dotted suffix of the current hostname is tried. Bare hosts
// (localhost) and IP addresses have no domain-scoped cookie to remove.
export const cookieDomainsFor = (hostname) => {
	const labels = (hostname || "").split(".").filter(Boolean);
	if (labels.length < 2 || labels.every((label) => /^\d+$/.test(label))) {
		return [];
	}
	return labels
		.slice(0, -1)
		.map((_label, index) => "." + labels.slice(index).join("."));
};

// Removes the flag cookie however it was scoped: the plain remove clears a
// host-only cookie, the domain removes clear the API-issued one (DCTL-2654).
const clearAuthenticated = () => {
	Cookies.remove(authCookieName);
	cookieDomainsFor(window.location.hostname).forEach((domain) => {
		Cookies.remove(authCookieName, { domain });
	});
};

// Full navigation so every page's state is dropped with the session; a router
// push can be cancelled by a guard and leave the old page on screen.
const leaveToLogin = () => {
	window.location.assign("/login");
};

export default {
	isAuthenticated,
	clearAuthenticated,
	leaveToLogin,
};
